import { render, staticRenderFns } from "./ArchivesTable.vue?vue&type=template&id=3bbbd77e&"
import script from "./ArchivesTable.vue?vue&type=script&lang=js&"
export * from "./ArchivesTable.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports